export default __webpack_public_path__ + "static/media/icon_export.31ec9a12.svg";